/**
 * IP service utilities.
 */

/**
 * Get the client's public IP address using the ipify API.
 * Replaces: IpServiceService.getIPAddress()
 *
 * @returns Promise resolving to the client's public IP address string
 * @throws Error if the API request fails
 */
export async function getClientIP(): Promise<string> {
  const response = await fetch('https://api64.ipify.org/?format=json');

  if (!response.ok) {
    throw new Error(`Failed to fetch IP address: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data.ip;
}
